<template>
  <div class="bottom">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push('../')">
        <img src="../assets/img/logo.svg" alt="">
      </a>
      <a class="menu_btn" href="javascript:;" @click="$router.push('../more')">
        <img src="../assets/img/menu.png" alt="">
      </a>
    </div>
    <div class="content" v-html='content'>
      
    </div>
    <detail-footer></detail-footer>
  </div>
</template>
<script>
import DetailFooter from './_footer'

export default {

  components: {
    DetailFooter
  },
  props: {
    index: [String, Number],
    // categoryName: [String],
  },
  data () {
    return {
      content : ''
    }
  },
  watch: {
      $route() {
          this.init()
      }
  },
  mounted(){
    this.init()
  },
  methods: {
    init(){
      this.$axios.get(`/api/web/phone/main-page/web-bottom`, {}).then(res => {  
        let data = res.data;
        let array = []
        let urlArray = []
        for(let index in data){
          if(data[index] && data[index].url){   
            let value = data[index].url ? data[index].url :'';
            urlArray.push(value);
          }
          if(data[index] && data[index].content){   
            let value = data[index].content ? data[index].content :'';
            array.push(value);
          }
        }
        this.url = urlArray[this.index-1] ? urlArray[this.index-1] : '';
        this.content = array[this.index-1] ? array[this.index-1] : '';
        // if(this.url){
        //   window.location.href = this.url
        // }
    });
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';
  
</style>
<style lang="scss" scoped>
  .content{
    min-height: calc(100vh - 66px);
    box-sizing: border-box;
    padding-top: 54px;
  }
  .bottom {
    overflow: hidden;
    background: #F5F5F5;
    min-height: 100vh;
    box-sizing:border-box;
    position: relative;
  }
  .header{
    height: 54px;
    background: #fff;
    border-bottom: 2px solid #f5f5f5;
    top: 0;
    left: 0;
    right: 0;
    position:fixed;
    z-index: 99;
    .logo{
      display: inline-block;
      // width: 155px;
      // height: 24px;
      position: absolute;
      top: 15px;
      left: 15px;
      img{
        height: 35px;
      }
    }
    .menu_btn{
      display: inline-block;
      position: absolute;
      top: 13px;
      right: 13px;
      width: 29px;
      height: 29px;
      img{
        width:100%;
        height:100%;
      }
    }
  }
  .footer{
    box-sizing: border-box;
    height: 66px;
    background: #0C324C;
    padding: 12px 0;
    li{
      color: #fff;
      font-size: 13px;
      height: 18px;
      span{
        width:6px;
        display: inline-block;
        text-align: center;
      }
      a{
        color: #fff;
      }
    }
    .footer_tip{
      margin-top: 7px;
    }
  }
</style>
<style>
.content img{
    max-width: 100%;
  }
/* p{
  font-size: 12px!important;
} */
</style>




// WEBPACK FOOTER //
// src/components/bottom.vue